<template>
  <div v-if="bind.boolCarregado">
    <v-tabs v-model="strTab" centered icons-and-text>
      <v-tab href="#tab-cadastro">
        Configuração Geral
        <i :class="$utilidade.getIcone('cadastroGeral') + ' fa-2x'"></i>
      </v-tab>
    </v-tabs>

    <ed-form
      :formData="formData.configuracaoEsocial.strValor"
      :handlerSave="strTab != 'tab-status' ? salvar : null"
      v-if="!this.$root.$session.loadingContent"
    >
      <cadastro-geral
        v-show="strTab == 'tab-cadastro'"
        :formData="formData"
        :key="'cadastro-geral-' + $root.$session.versao + strKey"
      />
    </ed-form>
  </div>
</template>

<script>
import Parametro from "@/components/common/parametro/editar";
import CadastroGeral from "./partials/geral.vue";

import { EdForm } from "@/components/common/form";

export default {
  name: "pageCadastroFuncao",
  props: {},
  components: {
    Parametro,
    CadastroGeral,
    EdForm,
  },
  provide() {
    return {
      bind: this.bind,
    };
  },
  mounted() {
    this.initialize();
  },
  created() {},
  data() {
    return {
      bind: {
        boolCarregado: false,
        arrayTipoAmbiente: [
          { intId: 1, strNome: "Produção" },
          { intId: 2, strNome: "Produção restrita" },
          { intId: 7, strNome: "Validação (uso interno)" },
          { intId: 8, strNome: "Teste (uso interno)" },
          { intId: 9, strNome: "Desenvolvimento (uso interno)" },
        ],
        arrayVersaoLayout: [
          //{ intId: 'S.1.0.0', strNome: "S.1.0.0" },
          { intId: 'S.1.1.0', strNome: "S.1.1.0" },
        ],
        arrayVersaoProcesso: [
          { intId: 'S_1.0.0', strNome: "S.1.0.0" },
        ],
        arrayVersaoWebservice: [
          { intId: '1.5.0', strNome: "1.5.0" },
        ],
        arrayHabilitar: [
          { intId: 1, strNome: "Sim" },
          { intId: 0, strNome: "Não" },
        ],
      },
      strTab: "tab-cadastro",
      strKey: this.$utilidade.randomString(),
      formData: {},
    };
  },
  watch: {},
  computed: {},
  methods: {
    initialize() {
      this.$root.$dialog.loading(true);

      Promise.all([
        this.$root.$request.get("Common/Parametro", {
          strChave: "configuracaoEsocial",
          boolBuscarSomenteAtivo: false,
        }),
      ]).then(([objConfiguracao]) => {
        this.$root.$dialog.loading(false);

        if (objConfiguracao.status == 200 && objConfiguracao.result) {
          if (!objConfiguracao.result.strValor) {
            objConfiguracao.result.strValor = {};
          }

          if (Number(objConfiguracao.result.strValor.strHorarioAtendimentoInicial)) {
            objConfiguracao.result.strValor.strHorarioAtendimentoInicial += ":00";
          }

          if (Number(objConfiguracao.result.strValor.strHorarioAtendimentoFinal)) {
            objConfiguracao.result.strValor.strHorarioAtendimentoFinal += ":00";
          }

          this.formData = {
            configuracaoEsocial: Object.assign(objConfiguracao.result, {}),
          };
        }

        this.bind.boolCarregado = true;
      });
    },

    salvar() {
      this.$root.$dialog.loading(true);

      this.$root.$request.post("Common/Parametro", this.formData).then((objResponse) => {
        this.$root.$dialog.loading(false);

        if (objResponse.status == 200) {
          (this.strKey = this.$utilidade.randomString()), this.initialize();
        }
      });
    },
  },
};
</script>
